/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { all, fork } from 'redux-saga/effects';
import { signInSaga } from 'modules/sign-in/saga';
import { authSaga } from 'modules/common/auth/saga';
import { forgotPasswordSaga } from 'modules/forgot-password/saga';
import { resetPasswordSaga } from 'modules/reset-password/saga';
import { verifyTokenSaga } from 'modules/verify-callback/saga';
import { visualSaga } from 'modules/visual/saga';
import { visualFilterSaga } from 'modules/visual-filter/saga';
import { eventCategoryConfigurationSaga } from 'modules/event-configuration/saga';
import { userSaga } from 'modules/users/saga';
import { llmSaga } from 'modules/llm/saga';
import { hotelSaga } from 'modules/hotels/saga';
import { userInvitesSaga } from 'modules/user-invitation/saga';
import { auditLogsSaga } from 'modules/audit-logs/saga';
import { hotelSetSaga } from 'modules/hotel-set/saga';
import { transactionSaga } from 'modules/transactions/saga';
import { systemSaga } from 'modules/system/saga';
import { scenarioSaga } from 'modules/scenario/saga';
import { platformSaga } from 'modules/platform-admin-settings/saga';
/**
 * Register all the saga functions into the root saga
 */
export default function* rootSaga() {
  yield all([
    fork(auditLogsSaga),
    fork(authSaga),
    fork(signInSaga),
    fork(forgotPasswordSaga),
    fork(resetPasswordSaga),
    fork(verifyTokenSaga),
    fork(visualSaga),
    fork(visualFilterSaga),
    fork(eventCategoryConfigurationSaga),
    fork(userSaga),
    fork(llmSaga),
    fork(hotelSaga),
    fork(userInvitesSaga),
    fork(hotelSetSaga),
    fork(transactionSaga),
    fork(systemSaga),
    fork(scenarioSaga),
    fork(platformSaga),
  ]);
}
